<header class="app-header">

    <!-- Left: Hamburger (mobile) + Logo -->
    <div class="header-left">
        <button class="hamburger" (click)="mobileMenuOpen.set(true)" type="button" aria-label="Open menu">
            <i class="pi pi-bars"></i>
        </button>

        <a class="app-logo" routerLink="/dashboard" aria-label="T-Shirt Cafe Admin — Dashboard">
            <img src="https://in-maa-1.linodeobjects.com/sava-s3/t-shirt-cafe-dev/branding/t-shirt-cafe-logo.svg" alt="T-Shirt Cafe" class="logo-img" />
            <span class="logo-badge">Admin</span>
        </a>
    </div>

    <!-- Center: Desktop Navigation -->
    <nav class="desktop-nav">
        @for (group of navGroups; track group.label) {

            @if (!group.children) {
                <a class="nav-item"
                   [routerLink]="group.route"
                   routerLinkActive="active"
                   (click)="activeDropdown.set(null)">
                    <i [class]="group.icon"></i>
                    <span>{{ group.label }}</span>
                </a>
            } @else {
                <div class="nav-dropdown-wrap">
                    <button class="nav-item"
                            type="button"
                            [class.active]="activeDropdown() === group.label"
                            (click)="toggleDropdown(group.label)">
                        <i [class]="group.icon"></i>
                        <span>{{ group.label }}</span>
                        <i class="pi pi-chevron-down chevron" [class.rotated]="activeDropdown() === group.label"></i>
                    </button>

                    @if (activeDropdown() === group.label) {
                        <div class="dropdown-menu">
                            @for (child of group.children; track child.label) {
                                <a class="dropdown-item" (click)="navigate(child.route)">
                                    <i [class]="child.icon"></i>
                                    <span>{{ child.label }}</span>
                                </a>
                            }
                        </div>
                    }
                </div>
            }
        }
    </nav>

    <!-- Right: Actions -->
    <div class="header-actions">
        <!-- Theme toggle temporarily hidden
        <button class="icon-btn" type="button"
                (click)="themeService.toggle()"
                [title]="themeService.isDarkMode() ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
            <i [class]="themeService.isDarkMode() ? 'pi pi-sun' : 'pi pi-moon'"></i>
        </button>
        -->


        <div class="notif-wrap">
            <button class="icon-btn notif-btn" type="button" title="Notifications" (click)="toggleNotifDropdown($event)">
                <i class="pi pi-bell"></i>
                @if (notifCount() > 0) {
                    <span class="notif-badge">{{ notifCount() }}</span>
                }
            </button>
            @if (notifDropdownOpen()) {
                <div class="notif-dropdown" (click)="$event.stopPropagation()">
                    <div class="notif-dropdown-head">
                        <strong>Notifications</strong>
                        @if (notifCount() > 0) {
                            <a class="link" (click)="markAllNotificationsRead($event)">Mark all read</a>
                        }
                    </div>
                    @if (!notifications.notifications().length) {
                        <div class="notif-empty"><i class="pi pi-inbox"></i><span>No notifications yet</span></div>
                    } @else {
                        <ul class="notif-list">
                            @for (n of notifications.notifications(); track n._id) {
                                <li class="notif-item" [class.unread]="!n.is_read" (click)="onNotifClick(n)">
                                    <span class="notif-icon"><i [class]="iconForType(n.type)"></i></span>
                                    <div class="notif-body">
                                        <div class="notif-title">{{ n.title }}</div>
                                        @if (n.message) { <div class="notif-msg">{{ n.message }}</div> }
                                        <div class="notif-time">{{ n.createdAt | date:'MMM d, h:mm a' }}</div>
                                    </div>
                                    @if (!n.is_read) { <span class="unread-dot"></span> }
                                </li>
                            }
                        </ul>
                    }
                </div>
            }
        </div>

        <div class="header-divider"></div>

        <button class="user-btn" type="button" (click)="toggleUserMenu($event)">
            <div class="user-avatar">{{ initials }}</div>
            <div class="user-info">
                <span class="user-name">{{ user?.name ?? 'Admin' }}</span>
                <span class="user-role">{{ user?.role === 'super_admin' ? 'Super Admin' : 'Admin' }}</span>
            </div>
            <i class="pi pi-chevron-down chev"></i>
        </button>

        <p-menu #userMenu [model]="userMenuItems" [popup]="true" />
    </div>
</header>

<!-- Mobile Drawer -->
<p-drawer [(visible)]="mobileMenuOpen" header="" [style]="{ width: '280px' }" styleClass="mobile-drawer">
    <ng-template #header>
        <div class="drawer-header">
            <div class="drawer-logo">
                <img src="https://in-maa-1.linodeobjects.com/sava-s3/t-shirt-cafe-dev/branding/t-shirt-cafe-logo.svg" alt="T-Shirt Cafe" class="drawer-logo-img" />
                <span class="drawer-logo-suffix">Admin</span>
            </div>
            <button class="drawer-close" type="button" (click)="mobileMenuOpen.set(false)">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </ng-template>

    <nav class="mobile-nav">
        @for (group of navGroups; track group.label) {

            @if (!group.children) {
                <a class="mobile-nav-item" (click)="navigate(group.route!)">
                    <i [class]="group.icon"></i>
                    <span>{{ group.label }}</span>
                </a>
            } @else {
                <div class="mobile-group">
                    <button class="mobile-group-header" type="button"
                            (click)="toggleMobileGroup(group.label)">
                        <div class="mobile-group-left">
                            <i [class]="group.icon"></i>
                            <span>{{ group.label }}</span>
                        </div>
                        <i class="pi pi-chevron-right mobile-chev"
                           [class.open]="mobileOpenGroup() === group.label"></i>
                    </button>
                    @if (mobileOpenGroup() === group.label) {
                        <div class="mobile-group-children">
                            @for (child of group.children; track child.label) {
                                <a class="mobile-child-item" (click)="navigate(child.route)">
                                    <i [class]="child.icon"></i>
                                    <span>{{ child.label }}</span>
                                </a>
                            }
                        </div>
                    }
                </div>
            }
        }
    </nav>
</p-drawer>
